<div class="d-flex">
  <div
    cdkDropList
    class="drag-drop-list"
    (cdkDropListDropped)="drop($event)"
    [ngStyle]="styles || defaultStyles"
  >
    <div [ngStyle]="getStyle()">
      @for (item of list; track item; let i = $index) {
        <div
          class="drag-drop-item"
          cdkDrag
          [ngStyle]="{ 'background-color': 'transparent' }"
        >
          {{ label ? allValuesMap[label] : item }}
        </div>
      }
    </div>
  </div>
  <div class="d-flex directions flex-column justify-content-around">
    @if (topDirectionText) {
      <div
        class="d-flex flex-column align-items-center justify-content-center pb-3"
      >
        <div><span class="arrow up-arrow">&#8593;</span></div>
        <div class="up-text">{{ topDirectionText }}</div>
      </div>
    }
    @if (bottomDirectionText) {
      <div
        class="d-flex flex-column align-items-center justify-content-center pt-3"
      >
        <div class="down-text">{{ bottomDirectionText }}</div>
        <div><span class="arrow down-arrow">&#8595;</span></div>
      </div>
    }
  </div>
</div>
